export default __webpack_public_path__ + "static/media/farmer.6d514af9.avif";